<template>
  <v-sheet color="#00aa9e" rounded>
    <v-sheet outlined rounded>
      <v-container style="min-height: 200px; max-height: 500px; overflow-y: auto;">
        <template>
            <v-row class="etapas-line ml-0 mr-0 font-weight-bold etapas-title" align="center" justify="center">
              <v-col class="pt-0 pb-0 auto-adjust-title" cols="12" sm="12" md="6">
                  <span class="mr-3">Etapas</span>
              </v-col>
              <v-col class="pr-0" cols="6" sm="6" md="3" align="center">
                <span class="mr-3">Qtd. Cam.</span>
              </v-col>
              <v-col class="pl-0" cols="6" sm="6" md="3" align="center">
                <span class="mr-3">Tons</span>
              </v-col>
            </v-row>
        </template>
        <template>
            <v-row v-for="(etapa, index) in this.etapas" :key="index"
                  class="etapas-line mt-1 ml-0 mr-0" align="center" justify="center">
              <v-col class="pt-0 pb-0 auto-adjust-title" cols="12" sm="12" md="6" style="display: ruby;">
                <div class="div-qty-etapas pl-3">
                  <span class="etapas-subtitle mb-2">{{ formatInfoValue(etapa.etapa_nome).toUpperCase() }}</span>
                </div>
              </v-col>
              <v-col class="pr-0 pt-0 pb-0" cols="6" sm="6" md="3" align="center">
                  <span class="font-weight-bold etapas-subtitle mr-3 mt-2">{{ formatInfoQty(etapa.count) }}</span>
              </v-col>
              <v-col class="pl-0 pt-0 pb-0" cols="6" sm="6" md="3" align="center">
                <span class="etapas-subtitle mt-2">{{ formatInfoTon(etapa.peso) }}</span>
              </v-col>
            </v-row>
        </template>
      </v-container>
    </v-sheet>
  </v-sheet>
</template>

<script>

export default {
  props: {
    etapas: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
    }
  },
  methods: { 
    formatInfoTon(value) {
      if (value === undefined || value === null) {
        return '0'
      } else {
        return parseFloat(value).toFixed(0)
      }
    },

    formatInfoQty(value) {
      if (value === undefined || value === null) {
        return '0'
      } else {
        return value
      }
    },

    formatInfoValue(value) {
      if (value === undefined || value === null) {
        return '-'
      } else {
        return value
      }
    },
  }
};
</script>

<style>
.div-qty-etapas {
  padding-top: 15px !important;
}

.etapas-line {
  border-bottom: 2px solid #00aa9e !important;
}

.etapas-title {
  font-family: 'Poppins', sans-serif !important;
  font-size: 0.975rem;
  text-transform: uppercase;
}

.etapas-subtitle {
  font-family: 'Poppins', sans-serif !important;
  font-size: 0.875rem;
  line-height: 100% !important; 
  text-transform: uppercase;
  display: inline-block;
}

@media only screen and (max-width: 959px) {
  .auto-adjust-title {
    text-align: center;
  }
}

@media only screen and (min-width: 960px) {
  .auto-adjust-title {
    text-align: left;
  }
}

</style>
